var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceMedtronic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1202_1552",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1202_1552)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8837 10.1395H26.8372V20.2326C26.8372 25.627 22.1726 30 16.4186 30C10.6646 30 6 25.627 6 20.2326V10.1395H6.02551C6.38341 5.58863 10.4625 2 15.4419 2C15.59 2 15.7374 2.00318 15.8839 2.00946C15.9528 2.00318 16.0225 2 16.093 2H22.6047C23.8633 2 24.8837 3.02038 24.8837 4.27907V10.1395ZM23.5814 10.1395H7.33263C7.6847 6.38347 11.1076 3.30233 15.4419 3.30233C15.5714 3.30233 15.7002 3.30511 15.8282 3.31059C15.8862 3.3131 15.9443 3.31167 16.0022 3.30642C16.0314 3.30376 16.0617 3.30233 16.093 3.30233H22.6047C23.1441 3.30233 23.5814 3.73963 23.5814 4.27907V6.23256H13.6512C13.0218 6.23256 12.5116 6.74275 12.5116 7.37209C12.5116 8.00144 13.0218 8.51163 13.6512 8.51163H23.5814V10.1395ZM7.30233 20.2326V11.4419H9.90698V13.8952C9.51771 14.1204 9.25581 14.5412 9.25581 15.0233C9.25581 15.7425 9.83888 16.3256 10.5581 16.3256C11.2774 16.3256 11.8605 15.7425 11.8605 15.0233C11.8605 14.5412 11.5986 14.1204 11.2093 13.8952V11.4419H12.8372V17.151C12.4479 17.3762 12.186 17.797 12.186 18.2791C12.186 18.9983 12.7691 19.5814 13.4884 19.5814C14.2076 19.5814 14.7907 18.9983 14.7907 18.2791C14.7907 17.797 14.5288 17.3762 14.1395 17.151V11.4419H15.7674V13.8952C15.3782 14.1204 15.1163 14.5412 15.1163 15.0233C15.1163 15.7425 15.6994 16.3256 16.4186 16.3256C17.1379 16.3256 17.7209 15.7425 17.7209 15.0233C17.7209 14.5412 17.459 14.1204 17.0698 13.8952V11.4419H18.6977V17.151C18.3084 17.3762 18.0465 17.797 18.0465 18.2791C18.0465 18.9983 18.6296 19.5814 19.3488 19.5814C20.0681 19.5814 20.6512 18.9983 20.6512 18.2791C20.6512 17.797 20.3893 17.3762 20 17.151V11.4419H21.6279V13.8952C21.2386 14.1204 20.9767 14.5412 20.9767 15.0233C20.9767 15.7425 21.5598 16.3256 22.2791 16.3256C22.9983 16.3256 23.5814 15.7425 23.5814 15.0233C23.5814 14.5412 23.3195 14.1204 22.9302 13.8952V11.4419H25.5349V20.2326C25.5349 24.8298 21.5338 28.6977 16.4186 28.6977C11.3034 28.6977 7.30233 24.8298 7.30233 20.2326Z",
    fill: "#006EBD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceMedtronic);
export default __webpack_public_path__ + "static/media/device-medtronic.45108c343ecff4377d39c21b115032cd.svg";
export { ForwardRef as ReactComponent };